








import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class VideoRequestViewDialog extends Vue {
  @Prop(Boolean) value?: boolean;
  @Prop(String) videoUrl?: string;

  @Watch("videoUrl")
  onVideoUrlChanged() {
    const myVideos = document.getElementsByTagName("video");
    for (let i = 0; i < myVideos.length; i++) {
      myVideos[i].load();
    }
  }

  close() {
    this.$emit("input");
  }
}
